import { Suspense, lazy } from 'react';
import AuthGuard from './components/AuthGuard';
import DashboardLayout from './views/Shared/DashboardLayout';
import GuestGuard from './components/GuestGuard';
// import RoleGuard from './components/RoleGuard';
import LoadingScreen from './components/LoadingScreen';
// import Change from './views/Shared/Change';
import Logout from './views/Authentication/Logout';
import ApprovedGuard from './components/ApprovedGuard';

const Loadable = (Component) => (props) => (
  <Suspense fallback={<LoadingScreen />}>
    <Component {...props} />
  </Suspense>
);

// Authentication pages

const Login = Loadable(lazy(() => import('./views/Authentication/Login')));
const PasswordRecovery = Loadable(lazy(() => import('./views/Authentication/PasswordRecovery')));
const PasswordReset = Loadable(lazy(() => import('./views/Authentication/PasswordReset')));
const ActivateMyAccount = Loadable(lazy(() => import('./views/Authentication/ActivateMyAccount')));
const Register = Loadable(lazy(() => import('./views/Authentication/Register')));
const VerifyCode = Loadable(lazy(() => import('./views/Authentication/VerifyCode')));
const Overview = Loadable(lazy(() => import('./views/Buyer/Dashboard/Overview')));
const Dashboard2 = Loadable(lazy(() => import('./components/dashboard/dashboard2/Dashboard2')));
const Account = Loadable(lazy(() => import('./views/Account/Account')));
const History = Loadable(lazy(() => import('./views/Buyer/Order/MyBidRequestList')));
const OrderHistoryDetails = Loadable(lazy(() => import('./views/Buyer/Order/OrderHistoryDetails')));
const DealDetail = Loadable(lazy(() => import('./views/Seller/Deals/DealDetail')));
const CreateOrder = Loadable(lazy(() => import('./views/Buyer/Order/CreateOrder')));
const Deals = Loadable(lazy(() => import('./views/Seller/Deals/Deals')));
const Chat = Loadable(lazy(() => import('./views/Shared/Chat/Chat')));
const BidResponseList = Loadable(lazy(() => import('./views/Seller/Orders/BidResponseList')));
// DUMMY PAGE
// const CustomerDetails = Loadable(lazy(() => import('./views/Buyer/Dashboard/CustomerDetails')));
// const CustomerEdit = Loadable(lazy(() => import('./views/Buyer/Dashboard/CustomerEdit')));
// const CustomerList = Loadable(lazy(() => import('./views/Buyer/Dashboard/CustomerList')));
const ServicesContent = Loadable(lazy(() => import('./components/seller/services/ServicesContent')));
// Error pages
const AuthorizationRequired = Loadable(lazy(() => import('./views/AuthorizationRequired')));
const NotFound = Loadable(lazy(() => import('./views/NotFound')));
const ServerError = Loadable(lazy(() => import('./views/ServerError')));
// Notification
const NotificationMain = Loadable(lazy(() => import('./views/Shared/NotificationMain')));
const Faq = Loadable(lazy(() => import('./views/Shared/Faq')));
const ContactUs = Loadable(lazy(() => import('./views/Shared/ContactUs')));
const NeedAprovement = Loadable(lazy(() => import('./views/NeedAprovement')));
const CreatePreDemand = Loadable(lazy(() => import('./views/PreDemand/CreatePreDemand')));
const PreDemands = Loadable(lazy(() => import('./views/PreDemand/PreDemands')));

// Profile

// const SocialProfile = Loadable(lazy(() => import('./views/Buyer/Dashboard/SocialProfile')));

const routes = [
  {
    path: '/login',
    element: (
      <GuestGuard>
        <Login />
      </GuestGuard>
    )
  },
  {
    path: '/password-recovery',
    element: (
      <GuestGuard>
        <PasswordRecovery />
      </GuestGuard>
    )
  },
  // {
  //   path: 'customers',
  //   children: [
  //     {
  //       path: '',
  //       element: <CustomerList />
  //     },
  //     {
  //       path: ':customerId',
  //       element: <CustomerDetails />
  //     },
  //     {
  //       path: ':customerId/edit',
  //       element: <CustomerEdit />
  //     }
  //   ]
  // },
  {
    path: '/password-reset',
    children: [
      {
        path: ':token',
        element: (
          <GuestGuard>
            <PasswordReset />
          </GuestGuard>
        )
      },
    ]
  },
  {
    path: '/activatemyaccount',
    children: [
      {
        path: ':token',
        element: (
          <GuestGuard>
            <ActivateMyAccount />
          </GuestGuard>
        )
      },
    ]
  },
  {
    path: '/register',
    element: (
      <GuestGuard>
        <Register />
      </GuestGuard>
    )
  },
  {
    path: '/verify-code',
    element: <VerifyCode />
  },
  {
    path: '/',
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (<Dashboard2 />)
        // element: (<RoleGuard
        //   buyer={<History />}
        //   seller={<Deals />}
        // />)
      },
      {
        path: '/account',
        element: (
          <Account />
        )
      },
      {
        path: '/predemands',
        children: [
          {
            path: '',
            element: (
              <ApprovedGuard>
                <PreDemands />
              </ApprovedGuard>
            )
          },
          {
            path: '/predemands/create',
            element: (
              <ApprovedGuard>
                <CreatePreDemand />
              </ApprovedGuard>
            )
          },
        ]
      },
      {
        path: '/orders',
        children: [
          {
            path: '',
            element: (
              <ApprovedGuard>
                <History />
              </ApprovedGuard>
            )
          },
          {
            path: '/orders/create',
            element: (
              <ApprovedGuard>
                <CreateOrder />
              </ApprovedGuard>
            )
          },
          {
            path: '/orders/:orderId',
            element: (
              <ApprovedGuard>
                <OrderHistoryDetails />
              </ApprovedGuard>
            )
          },
        ]
      },
      {
        path: '/bids',
        children: [
          {
            path: '',
            element: (
              <ApprovedGuard>
                <BidResponseList />
              </ApprovedGuard>
            )
          },
          {
            path: '/bids/:orderId',
            element: (
              <ApprovedGuard>
                <DealDetail />
              </ApprovedGuard>
            )
          },
        ]
      },
      {
        path: '/deals',
        children: [
          {
            path: '',
            element: (
              <ApprovedGuard>
                <Deals />
              </ApprovedGuard>
            )
          },
          {
            path: '/deals/:searchText',
            element: (
              <ApprovedGuard>
                <Deals />
              </ApprovedGuard>
            )
          },
        ]
      },
      // {
      //   path: '/deals',
      //   element: (
      //     <Deals />)
      // },
      {
        path: '/chat',
        children: [
          {
            path: '',
            element: (
              <Chat />
            )
          },
          {
            path: '/chat/:clientId',
            element: (
              <Chat />
            )
          },
        ]
      },
      {
        path: '/help',
        element: (
          <Faq />
        )
      },
      {
        path: '/contactus',
        element: (
          <ContactUs />
        )
      },
      {
        path: '/needapprovement',
        element: (
          <NeedAprovement />
        )
      },
      // {
      //   path: 'customers',
      //   children: [
      //     {
      //       path: '/',
      //       element: <CustomerList />
      //     },
      //     {
      //       path: ':customerId',
      //       element: <CustomerDetails />
      //     },
      //     {
      //       path: ':customerId/edit',
      //       element: <CustomerEdit />
      //     }
      //   ]
      // },
      {
        path: 'profile',
        children: [
          // {
          //   path: '/',
          //   element: <SocialProfile />
          // },
          {
            path: '/profile/:clientId',
            element: <ServicesContent />
          }
        ]
      },
      {
        path: '/dashboard',
        element: (
          <Overview />
        )
      },
      // {
      //   path: '/dashboard2',
      //   element: (
      //     <Dashboard2 />
      //   )
      // },
      {
        path: 'notifications',
        element: <NotificationMain />
      },
      {
        path: 'logout',
        element: <Logout />
      },
      {
        path: '401',
        element: <AuthorizationRequired />
      },
      {
        path: '404',
        element: <NotFound />
      },
      {
        path: '500',
        element: <ServerError />
      },
      {
        path: '*',
        element: <NotFound />
      }
    ]
  },
];

export default routes;
